import React from "react";
import { MenuLayout } from "../../themes/SwitchTheme";
import CashDeskSimulator from "./CashDeskSimulator";

export default class CashDeskSimulatorPage extends React.Component {
  render() {
    return (
      <MenuLayout>
        <h1>Shop</h1>
        <CashDeskSimulator />
      </MenuLayout>
    );
  }
}
